import { render, staticRenderFns } from "./NoteAndDetailSectionPayment.vue?vue&type=template&id=4a10bd3e&"
import script from "./NoteAndDetailSectionPayment.vue?vue&type=script&lang=js&"
export * from "./NoteAndDetailSectionPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports